<div class="flex flex-col h-full w-full justify-center items-center">
  <span class="icon-Success_ico text-green-2 text-[35px] mb-[12px]"></span>
  <h1 class="text-b2-dark-brick text-[18px] leading-[24px] font-magnet-bold mb-[32px]">
    {{ 'Mittanbud will reach out soon!' | translate }}
  </h1>
  <div
    (click)="close()"
    class="uppercase relative rounded-[4px] cursor-pointer bg-b1-poppy-hammer mx-auto text-12 leading-[16px] font-[500] w-[58px] h-[36px] text-white border border-orange-btn-border flex justify-center items-center">
    <span>{{ 'Ok' | translate }}</span>
  </div>
</div>
